<template>
  <div class="line-item-customizations">
    <v-link
      :href="previewImage"
      target="_blank"
      class="line-item-customizations__option-link"
      :label="$t('view_attached_photo')"
    />
  </div>
</template>

<script>
import isExternalLink from '~/utils/isExternalLink'
import VLink from '~/components/v-link/VLink.vue'

export default {
  components: { VLink },
  props: {
    giftProp: {
      type: Boolean,
      default: null,
    },
    customizationsProp: {
      type: [Object, Array],
      default: null,
    },
    showCustomizationsProp: {
      type: Boolean,
      default: true,
    },
    previewImage: {
      type: String,
      default: null,
    },
  },
  methods: {
    isLink(str) {
      return isExternalLink(str) && !str.includes('@')
    },
    isColor(str) {
      const temp = str.toLowerCase()
      return temp.includes('cor') || temp.includes('color')
    },
  },
}
</script>

<style lang="scss" scoped>
.line-item-customizations {
  .line-item-customizations__option-title {
    display: inline-block;
    margin-top: 2px;
  }

  .line-item-customizations__option-link {
    color: $v4_color_primary;

    &:hover {
      text-decoration: none;
    }
  }

  .line-item-customizations__option-color {
    border: 1px solid $v4_color_line;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: sub;
  }
}
</style>
